"use client";

import { useCallback } from "react";

import { useHashModal } from "@/hooks/use-hash-modal";

const GUEST_SIGNUP_MODAL = "guest-signup";

export function useGuestSignupDialog() {
  const { close, getState, open } = useHashModal();
  const state = getState(GUEST_SIGNUP_MODAL);
  const openGuestSignup = useCallback(() => {
    open(GUEST_SIGNUP_MODAL);
  }, [open]);
  const setGuestSignupOpen = useCallback(
    (nextOpen: boolean) => {
      if (nextOpen) {
        open(GUEST_SIGNUP_MODAL);
        return;
      }
      close(GUEST_SIGNUP_MODAL);
    },
    [close, open],
  );

  return {
    openGuestSignup,
    setGuestSignupOpen,
    signupOpen: state.open,
  };
}
